import { render } from "./PedirCuenta.vue?vue&type=template&id=026b05a8&scoped=true"
import script from "./PedirCuenta.vue?vue&type=script&lang=js"
export * from "./PedirCuenta.vue?vue&type=script&lang=js"

import "./PedirCuenta.vue?vue&type=style&index=0&id=026b05a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026b05a8"]])

export default __exports__